<template lang="pug">
#downdraft-top.downdraft-trail
	ol.downdraft-trail__tracker
		li.downdraft-trail__step(v-for="step in config", :class="stepClass(step)")
			span.downdraft-trail__step-text {{ step.title }}
			span.downdraft-trail__step-marker(:class="step.step < session.step ? 'checkmark' : 'count'", @click="goToStep(step.step)")
</template>

<script>
export default {
  name: 'Trail',
  props: ['session', 'config'],
  methods: {
    stepClass(step) {
      if (step.step === this.session.step) {
        return 'is-active'
      } else if (step.step === this.session.step - 1) {
        return 'is-most-recent'
      } else if (step.step < this.session.step) {
        return 'is-complete'
      }
    },
    goToStep(step) {},
  },
}
</script>

<style lang="scss" scoped>
$tracker-secondary-color: #cfcfcf;
$tracker-primary-color: #376074;
$tracker-marker-size: 34px;
$tracker-text-color: #000000;
$tracker-line-size: 8px;
$line-offset: calc((#{$tracker-marker-size}/ 2) + 1em);

@mixin rounded-corners($radius) {
  border-radius: $radius;
}

.downdraft-trail {
  align-items: center;
  justify-content: space-between;
  flex: 2 0 auto;
  width: 100%;
  &__tracker {
    display: flex;
    margin: 2rem auto 1rem auto;
    padding: 0;
    list-style: none;
    counter-reset: item;
  }
  &__step {
    display: block;
    position: relative;
    flex: 1 1 0;
    padding: 0;
    min-width: $tracker-marker-size;

    &::after {
      background-color: $tracker-secondary-color;
    }
    &:last-child {
      flex-grow: 0;
    }
    &:not(:last-child)::after {
      content: '';
      display: block;
      position: absolute;
      z-index: -10;
      top: $line-offset;
      left: 45px;
      width: calc(100% - 45px - 10px);
      height: $tracker-line-size;
      @include rounded-corners(4px);
    }
    &:first-of-type {
      .downdraft-trail__step-text {
        text-align: left !important;
        transform: unset;
      }
    }
    &:last-of-type {
      .downdraft-trail__step-text {
        position: absolute;
        right: 0;
        top: 2px;
        text-align: right !important;
        transform: unset;
      }
      .downdraft-trail__step-marker {
        margin-top: 1.3rem;
      }
    }
    &-text {
      text-overflow: ellipsis;
      text-align: center;
      display: inline-block;
      white-space: nowrap;
      font-size: 0.9em;
      padding-right: 0;
      padding-left: 0;
      transform: translateX(calc(-50% + (#{$tracker-marker-size}/ 2)));
      @media (max-width: 768px) {
        visibility: hidden;
      }
    }
    &-marker {
      transition: all 0.25s ease-in-out;
      color: $tracker-text-color;
      background-color: $tracker-secondary-color;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 1;
      width: $tracker-marker-size;
      height: $tracker-marker-size;
      font-weight: bold;
      border-radius: 50%;
    }
    &.is-active .downdraft-trail__step-marker {
      background-color: $tracker-text-color;
      color: #ffffff;
    }
    &.is-complete .downdraft-trail__step-marker,
    &.is-most-recent .downdraft-trail__step-marker {
      background-color: $tracker-primary-color;
    }
    &.is-most-recent::after {
      background: linear-gradient(to right, $tracker-primary-color, $tracker-secondary-color);
    }
    &.is-complete::after {
      background: $tracker-primary-color;
    }
  }
  .count:before {
    content: counter(item) ' ';
    counter-increment: item;
  }
  .checkmark:after {
    content: '';
    counter-increment: item;
    display: block;
    width: 0.5em;
    height: 1em;
    border: solid white;
    border-width: 0 0.2em 0.2em 0; // creates the inverted "L" shape
    position: absolute;
    left: 0.8em;
    top: 30%;
    margin-top: -0.2em;
    transform: rotate(45deg);
  }
}
</style>
